import React, { useMemo } from 'react'
import { QuickTableCellProps } from 'react-ui-scaffold'
import { formatCurrency } from '../../utils/formatUtils'
import { CELL_SPAN_STYLE } from './cellStyles'

export default function CurrencyCell({ cell, style, className }:QuickTableCellProps) {
	const display = useMemo(() => formatCurrency(cell), [cell])
	
	return (
		<span
			style={{
				...CELL_SPAN_STYLE,
				textAlign: 'center',
				...style,
			}}
			className={className}
		>
			{display}
		</span>
	)
}
